import { url } from "./apiurl";

async function read(path, signal) {
  const response = await fetch(`${url}/commonly-ask/${path}`, { signal });
  if (!response.ok) {
    const error = new Error(response.status === 404 ? "This page is currently unavailable." : "Unable to load Commonly Ask. Please try again.");
    error.status = response.status;
    throw error;
  }
  const data = await response.json();
  if (!data || !Array.isArray(data.products)) throw new Error("Unable to load Commonly Ask. Please try again.");
  return data;
}
export const commonlyAskApi = {
  home: signal => read("home", signal),
  page: (page, signal) => read(`page?page=${page}&limit=12`, signal),
  all: async signal => {
    const first = await read("page?page=1&limit=100", signal);
    const rest = await Promise.all(Array.from({ length: Math.max(0, first.pages - 1) },
      (_, index) => read(`page?page=${index + 2}&limit=100`, signal)));
    return { ...first, products: [first, ...rest].flatMap(result => result.products) };
  },
};
